export default __webpack_public_path__ + "src/images/packages/hillsneck-safari-lodge/cf843652e6306127d15013d185bbeb9b-HillsNek Boma Evening.jpg";